import { render } from "./MoreDetailsRoster9View.vue?vue&type=template&id=8d212e90&scoped=true"
import script from "./MoreDetailsRoster9View.vue?vue&type=script&lang=js"
export * from "./MoreDetailsRoster9View.vue?vue&type=script&lang=js"

import "./MoreDetailsRoster9View.vue?vue&type=style&index=0&id=8d212e90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d212e90"]])

export default __exports__